import React, { useEffect, useState } from 'react';
import { Icon } from '@b-design/fusion';
import Button from '@/components/Button';
import AddDrawer from './component/addDrawer';
import DragCard from './component/dragCard';
import Unsorted from './component/unsorted';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import $i18n from '@/i18n';
import './index.less';

const RightCard: React.FC = (props) => {
  const { channelCode } = getQueryStringArgs();
  const { checkItem } = props;
  const [visible, setVisible] = useState(false);
  const [bindAppList, setBindAppList] = useState([]);
  const [noBindList, setNoBindList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  // 分页参数
  const [paginationValue, setPaginationValue] = useState<Record<'pageNum' | 'pageSize', number>>({
    pageNum: 1,
    pageSize: 10,
  });

  const getBindAppList = () => {
    Requests.post('/rest/intercnn/channel/category/miniapp/list', {
      channelCode,
      categoryId: checkItem,
    }).then((res) => {
      if (res) {
        res.sort((a, b) => a.sort - b.sort);
        setBindAppList(res);
      }
    });
  };

  const getNoBindList = (
    params = {
      pageNum: 1,
      pageSize: 10,
      channelCode,
      categoryId: checkItem,
    },
  ) => {
    Requests.post('/rest/intercnn/channel/category/miniapp/listNoBind', {
      ...params,
    }).then((res) => {
      res.list.map((item) => (item.id = item.miniappCode));
      // const list = res.list.filter((i) => i.publishStatus === 'ONLINE');
      setTotalCount(res.total);
      setNoBindList(res.list);
    });
  };

  useEffect(() => {
    getBindAppList();
  }, [checkItem]);

  return (
    <div className="rightCard">
      <div className="card-title">
        <div>
          {$i18n.get({
            id: 'aopf.pages.miniAppStore.operate.setting.category.membership',
            dm: '类目成员',
          })}
        </div>
        {checkItem !== -1 && (
          <Button
            type="primary"
            data-child-type="icon-text"
            id="btn-create-miniapp"
            onClick={() => {
              setVisible(true);
              getNoBindList();
              setPaginationValue({
                pageNum: 1,
                pageSize: 10,
              });
            }}
          >
            <Icon type="add--circle--filled" />
            {$i18n.get({
              id: 'aopf.pages.miniAppStore.operate.setting.createMiniapp',
              dm: '选择小程序',
            })}
          </Button>
        )}
      </div>

      <AddDrawer
        visible={visible}
        setVisible={setVisible}
        checkItem={checkItem}
        getBindAppList={getBindAppList}
        getNoBindList={getNoBindList}
        noBindList={noBindList}
        totalCount={totalCount}
        setPaginationValue={setPaginationValue}
        paginationValue={paginationValue}
      />
      {checkItem === -1 ? (
        <Unsorted />
      ) : (
        <DragCard bindAppList={bindAppList} getBindAppList={getBindAppList} checkItem={checkItem} />
      )}
    </div>
  );
};

export default RightCard;
